var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-overlay",
    {
      attrs: { "z-index": "9999999999" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "card_style animated zoomIn",
          attrs: {
            elevation: 5,
            rounded: "",
            light: "",
            "min-width": "300",
            "max-width": "600",
          },
        },
        [
          _c(
            "v-toolbar",
            {
              staticStyle: { background: "#fff", "padding-right": "0px" },
              attrs: { flat: "", dense: "", height: "40" },
            },
            [
              _c("v-toolbar-title", { staticClass: "text-h4" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticStyle: { padding: "32px 16px" } },
            [
              _vm._t("content", function () {
                return [
                  _c(
                    "v-sheet",
                    {
                      staticClass: "text-body-1",
                      domProps: { innerHTML: _vm._s(_vm.text) },
                    },
                    [_vm._v(_vm._s(_vm.text))]
                  ),
                ]
              }),
            ],
            2
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._l(_vm.button, function (item, index) {
                return _c(
                  "v-btn",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.show,
                        expression: "item.show",
                      },
                    ],
                    key: "button--" + index,
                    staticClass: "btn_style",
                    attrs: { text: "", rounded: "" },
                    on: { click: item.ontap },
                  },
                  [_vm._v(_vm._s(item.text))]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }